import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { fetchNewsPublishedPath } from 'hb-react/shared/apps/News/NewsPublished/utils/newsUrls';
import { getQueryKey } from 'hb-react/shared/apps/News/NewsPublished/utils/queryUtils';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const useNewsPublished = (newsId, userId) => {
  const { topicId, whitelabelURL } = useTopicContext();
  const { data, isLoading, error } = useQuery({
    queryKey: getQueryKey(newsId),
    queryFn: async () => {
      try {
        return await fetchNewsPublished({
          newsId,
          topicId,
          userId,
          whiteLabelEnabled: !!whitelabelURL,
        });
      } catch (error) {
        if (error?.response?.status === 403) {
          displayXhrError(error);
        }
        throw error;
      }
    },
    enabled: !!newsId,
    staleTime: ms('5m'),
  });

  return {
    error,
    isLoading,
    news: data?.postCommunication,
  };
};

const fetchNewsPublished = ({ newsId, topicId, userId, whiteLabelEnabled }) =>
  axios
    .get(fetchNewsPublishedPath({ newsId, topicId, userId, whiteLabelEnabled }))
    .then((res) => res.data);
